import { gql } from '@apollo/client';

export const UPDATE_ASSESSMENT_STATUS = gql`
  mutation updateAssessmentStatus($assessmentRequest: AssessmentRequest) {
    updateAssessmentStatus(assessmentRequest: $assessmentRequest) {
      statusMessage
    }
  }
`;

export const GET_SUBMITTED_ASSESSMENT_DETAILS = gql`
  query getAssessmentDetailsforView($assessmentInstanceId: Int) {
    getAssessmentDetailsforView(assessmentInstanceId: $assessmentInstanceId)
  }
`;
